<template>
    <div>
        <div class="table-list">
            <!-- 服务器远程列表 -->
            <div>
                <header-tag
                    class="table-header"
                    :title="
                        '服务器远程' +
                            ' (' +
                            barServerList.bsOnline +
                            '/' +
                            barServerList.bsSum +
                            ')'
                    "
                ></header-tag>
                <server-list
                    class="table-content"
                    :loading="serverLoading"
                    :table-list="barServerList.list"
                    @delOffServer="delOffServer"
                    @setServerLabel="setServerLabel"
                ></server-list>
            </div>
            <!-- 路由器远程列表 -->
            <div>
                <header-tag
                    class="table-header"
                    :title="'路由器远程' + ' (' + barRouteList.brSum + ')'"
                ></header-tag>
                <router-list
                    class="table-content"
                    @refresh="init"
                    :loading="routerLoading"
                    :table-list="barRouteList.list"
                ></router-list>
            </div>
            <!-- 客户机远程列表 -->
            <div>
                <header-tag
                    class="table-header"
                    :title="
                        '客户机远程' +
                            ' (' +
                            barClientList.bcOline +
                            '/' +
                            barClientList.bcSum +
                            ')'
                    "
                ></header-tag>
                <client-list
                    class="table-content"
                    :loading="clientLoading"
                    :table-list="barClientList.list"
                ></client-list>
                <div
                    class="table-pagination"
                    style="overflow:hidden;padding-top:10px;padding-right:20px;"
                >
                    <page-component
                        :total="barClientList.total"
                        :current-page="barClientList.pageNum"
                        :display="15"
                        @pagechange="getBarClientList"
                        style="float:right;margin-right:20px;"
                    ></page-component>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
// tag组件
import HeaderTag from "_c/tagTitle/headerTag";
// 服务器远程
import ServerList from "./serverList";
// 路由器远程
import RouterList from "./routerList";
// 客户机远程
import ClientList from "./clientList";
// 分页功能
import PageComponent from "_c/pagination/pageComponent";

import {
    getBarServerList,
    getBarRouteList,
    getBarClientList,
    delOfflineBs,
    setServerLabel
} from "@/requests/bar";
import { mapActions } from "vuex";
export default {
    components: {
        HeaderTag,
        ServerList,
        RouterList,
        ClientList,
        PageComponent
    },
    data() {
        return {
            barServerList: {
                list: [],
                bsOnline: 0,
                bsSum: 0
            },
            serverLoading: false,
            barRouteList: {
                list: [],
                brSum: 0
            },
            routerLoading: false,
            barClientList: {
                list: [],
                pageNum: 1,
                pageSize: 15,
                total: 0,
                bcSum: 0,
                bcOline: 0
            },
            clientLoading: false
        };
    },
    mounted() {
        this.init();
    },
    watch: {
        /* eslint-disable */
        $route(to, from) {
            this.init();
        }
    },
    methods: {
        ...mapActions(["serverLabel/actionUpdateLabelInfo"]),
        init() {
            this.getBarServerList();
            this.getBarRouteList();
            this.getBarClientList(1);
            this["serverLabel/actionUpdateLabelInfo"]();
        },
        // 获取服务器列表
        async getBarServerList() {
            this.barServerList.list = [];
            this.serverLoading = true;
            if (this.$route.params.id == undefined) {
                return false;
            }
            let res = await getBarServerList({
                barId: this.$route.params.id
            });
            this.barServerList.list = res.bsInfoList;
            this.barServerList.bsOnline = res.bsOnline;
            this.barServerList.bsSum = res.bsSum;
            this.serverLoading = false;
        },
        async delOffServer(item) {
            let label =
                item.nickName == "-" || !item.nickName
                    ? "无标签"
                    : item.nickName;
            window.$Message.show({
                title: "删除服务器",
                type: "info",
                msg:
                    '是否删除离线服务器"' +
                    item.computerName +
                    "(" +
                    item.localIp +
                    ", " +
                    label +
                    ')" ?',
                cancleBtn: true,
                confirmFn: async () => {
                    let res = await delOfflineBs({
                        barId: item.barId,
                        bsFlag: item.flag
                    });
                    if (res.code === 200) {
                        setTimeout(() => {
                            window.$Message.show({
                                title: "删除服务器",
                                type: "success",
                                msg:
                                    "删除成功！删除操作可能存在延迟，若删除的服务器仍会显示，请刷新页面即可。",
                                confirmFn: async () => {
                                    window.$Message.hide();
                                }
                            });
                        }, 100);
                        this.getBarServerList();
                    } else {
                        setTimeout(() => {
                            window.$Message.show({
                                title: "删除服务器",
                                type: "error",
                                msg: res.msg
                            });
                        }, 100);
                    }
                }
            });
        },
        async setServerLabel(barId, flag, labelId, computerName) {
            let list = [
                {
                    barId: barId,
                    barServerFlag: flag,
                    computerName: computerName
                }
            ];
            let res = await setServerLabel({
                serverList: list,
                labelId: labelId,
                search: ""
            });
            if (res.code === 200) {
                this.getBarServerList();
            } else {
                window.$Message.show({
                    title: "服务器标签管理",
                    type: "error",
                    msg: res.msg
                });
            }
        },
        // 获取路由列表
        async getBarRouteList() {
            this.barRouteList.list = [];
            this.routerLoading = true;
            if (this.$route.params.id == undefined) {
                return false;
            }
            let res = await getBarRouteList({
                barId: this.$route.params.id
            });
            this.barRouteList.list = res;
            this.barRouteList.brSum = res.length;
            this.routerLoading = false;
        },
        // 获取客户机列表
        async getBarClientList(pageNum) {
            this.barClientList.list = [];
            this.clientLoading = true;
            this.barClientList.pageNum = pageNum;
            if (this.$route.params.id == undefined) {
                return false;
            }
            let res = await getBarClientList({
                barId: this.$route.params.id,
                pageNum: this.barClientList.pageNum,
                pageSize: this.barClientList.pageSize
            });
            res.list.forEach(item => {
                item.barId = this.$route.params.id;
                item.localIp = item.ip;
            });
            this.barClientList.list = res.list;
            this.barClientList.total = parseInt(res.total ? res.total : 0);
            this.barClientList.pageNum = parseInt(
                res.current ? res.current : 1
            );
            this.barClientList.bcOline = res.bcOnline;
            this.barClientList.bcSum = res.bcSum;
            this.clientLoading = false;
        }
    }
};
</script>
<style lang="scss" scoped>
.table-list {
    padding-left: 30px;
    padding-top: 10px;
    > div {
        padding-bottom: 20px;
    }
}
.table-content {
    position: relative;
    left: -10px;
    padding-right: 20px;
}
.table-header {
    margin-bottom: 10px;
}
</style>
